import React from "react";
import styled from "styled-components";
import avatarList from "config/avatarList";
import media from "cssMix/index";

const StyledAvatar = styled.div`
  display: flex;
  margin-bottom: 32px;
  & .amount-area {
    display: none;
  }
  & .account {
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    margin-left: 12px;
  }
  & .avatar-img {
    cursor: pointer;
    width: 44px;
    height: 44px;
    border-radius: 20px;
    background: ${(props) => `url("${props.avatar}")
      no-repeat top center`};
    background-size: cover;
  }
  & .avatar-mask {
    width: 100%;
    height: 100%;
    background: url("images/avatar_mask.png") no-repeat left center;
    background-size: cover;
  }
  ${media.tablet`
  margin-bottom: 0;
  
  `}
`;

const Avatar = ({
  account,
  avatarPopHandler,
  userAvatar,
  handleRefreshClick,
  currency,
  balance,
}) => {
  const avatarImg = avatarList
    .filter((v) => v.get("id") === userAvatar)
    .getIn([0, "avatar"]);
  return (
    <StyledAvatar avatar={avatarImg}>
      <div className="avatar-img gav2_btn_avatar" onClick={avatarPopHandler}>
        <div className="avatar-mask" />
      </div>
      <p className="account">{account}</p>
    </StyledAvatar>
  );
};

export default Avatar;
